import type { ClientOwnerReassignRequest, ClientOwnerReassignResponse } from "@repo/shared/types";
import { post } from "./_client";

export const reassignClients = (fromUserId: string, body: ClientOwnerReassignRequest) =>
  post<ClientOwnerReassignResponse>(
    `/internal/users/${fromUserId}/reassign-clients`,
    body satisfies ClientOwnerReassignRequest,
  );
